"use strict";
/*!
// <copyright file="DataCache.js" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var $dyn;
(function ($dyn) {
    $dyn.DataCacheManager = {};
    var reactGrid;
    (function (reactGrid) {
        /* Constants */
        var CACHE_FILL_TIME = 500; // 0.5 sec
        var SCROLLED_PAGE_LOAD_TIME = 1000; // 1 sec
        var MIN_PAGE_SIZE = 25;
        var INITIAL_CACHE_CAPACITY = 200;
        var MAX_ROWS_SCROLLED_PER_SEC = 100;
        var DataCache = /** @class */ (function () {
            function DataCache(loadFunction, context, dataSource) {
                var _this = this;
                this.loadFunction = loadFunction;
                this.context = context;
                this.dataSource = dataSource;
                this.fastFetch = true;
                this.currentPageSize = MIN_PAGE_SIZE;
                this.lastRequestedPageSize = 0;
                this.initialCacheCapacity = INITIAL_CACHE_CAPACITY; // TODO: should be based on usage data
                this.isLoading = false;
                this.loadDirection = $dyn.ui.ScrollDirection.none;
                this.resetObserver = null;
                this.isDisposed = false;
                var rootId = context.Root && context.Root.Id;
                if (rootId && $dyn.isServerBoundDataSource(dataSource)) {
                    this.modelCollection = dataSource.__boundDataSource;
                    if (this.modelCollection.onClear) {
                        this.clearSubscription = this.modelCollection.onClear.subscribe(function () {
                            if (!_this.fastFetch && _this.isPrimary) {
                                _this.fastFetch = true;
                                _this.fastFetchData();
                            }
                        });
                    }
                    if (!$dyn.DataCacheManager[rootId]) {
                        $dyn.DataCacheManager[rootId] = {};
                    }
                    var dsName = this.modelCollection.name;
                    if (!$dyn.DataCacheManager[rootId][dsName]) {
                        $dyn.DataCacheManager[rootId][dsName] = {};
                        this.isPrimary = true;
                    }
                    else {
                        // there is already a dataCache that will fastFetch this ds
                        this.isPrimary = false;
                        this.fastFetch = false;
                    }
                    $dyn.DataCacheManager[rootId][dsName][context.Name] = this;
                }
                // Determine if the cache size should be capped
                var flightedCacheCapacity = $dyn.util.getFlightValue("MaxReactGridRows");
                if (flightedCacheCapacity && flightedCacheCapacity > 0) {
                    this.maxCacheCapacity = flightedCacheCapacity;
                }
                else {
                    this.maxCacheCapacity = null;
                }
                this.fastFetchData();
            }
            DataCache.flipDirection = function (direction) {
                var flippedDirection = $dyn.ui.ScrollDirection.none;
                if (direction === $dyn.ui.ScrollDirection.up) {
                    flippedDirection = $dyn.ui.ScrollDirection.down;
                }
                else if (direction === $dyn.ui.ScrollDirection.down) {
                    flippedDirection = $dyn.ui.ScrollDirection.up;
                }
                return flippedDirection;
            };
            Object.defineProperty(DataCache.prototype, "LoadDirection", {
                get: function () {
                    if ($dyn.serverForm && $dyn.serverForm.ModelManager) {
                        return $dyn.serverForm.ModelManager.loadDirection;
                    }
                    return this.loadDirection;
                },
                set: function (value) {
                    if (this.resetObserver) {
                        this.resetObserver.dispose();
                        this.resetObserver = null;
                    }
                    if ($dyn.serverForm && $dyn.serverForm.ModelManager) {
                        $dyn.serverForm.ModelManager.loadDirection = value;
                    }
                    else {
                        this.loadDirection = value;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DataCache.prototype, "MaxCacheSize", {
                get: function () {
                    return this.maxCacheCapacity;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DataCache.prototype, "PageSize", {
                get: function () {
                    return this.currentPageSize;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DataCache.prototype, "PageBufferFactor", {
                get: function () {
                    if (this.currentPageSize < MAX_ROWS_SCROLLED_PER_SEC) {
                        // Minimum buffer should be number of rows user can scroll per second
                        return (MAX_ROWS_SCROLLED_PER_SEC / this.currentPageSize);
                    }
                    return 1;
                },
                enumerable: false,
                configurable: true
            });
            DataCache.prototype.fastFetchData = function () {
                var _this = this;
                if (this.fastFetch && this.context) {
                    var loadDirection_1 = $dyn.ui.ScrollDirection.none;
                    if ($dyn.value(this.context.DataAbove)) {
                        loadDirection_1 = $dyn.ui.ScrollDirection.up;
                    }
                    else if ($dyn.value(this.context.DataBelow)) {
                        loadDirection_1 = $dyn.ui.ScrollDirection.down;
                    }
                    else {
                        // Possible the server cache is full but the client doesn't have all the data
                        if ($dyn.value(this.context.HasPreviousPage)) {
                            loadDirection_1 = $dyn.ui.ScrollDirection.up;
                        }
                        else if ($dyn.value(this.context.HasNextPage)) {
                            loadDirection_1 = $dyn.ui.ScrollDirection.down;
                        }
                    }
                    if (this.context.MayHaveMoreData && this.context.MayHaveMoreData(loadDirection_1)) {
                        // Need to be in a timeout so that an outgoing request isn't created while processing incoming requests
                        window.setTimeout(function () {
                            _this.dataLoadNew(function (retVal) {
                                _this.defaultCallBack(retVal);
                            }, loadDirection_1);
                        });
                    }
                    else {
                        this.fastFetch = false;
                    }
                }
            };
            DataCache.prototype.defaultCallBack = function (retValue) {
                var _this = this;
                this.loadTime = Date.now() - this.startTime;
                if (retValue !== -1) {
                    this.isLoading = false;
                    var resetDirection = true;
                    var sizeDifference = $dyn.length(this.dataSource) - this.prevItemsLength;
                    var sameSize = (sizeDifference === 0);
                    if (this.context) {
                        this.context.updateConfirmations(this.LoadDirection, sameSize);
                    }
                    // subtract 1 because the pages overlap by one
                    if (sizeDifference >= this.lastRequestedPageSize - 1) {
                        // only update page size if the request got a full page of data
                        var optimalTime = ($dyn.length(this.dataSource) < this.initialCacheCapacity) ? CACHE_FILL_TIME : SCROLLED_PAGE_LOAD_TIME;
                        // If time is within 10% of target leave the page size alone
                        // Current server limitation that the pageSize can only grow (Deliverable 263308)
                        var newPageSize = this.currentPageSize;
                        if (this.loadTime < 0.9 * optimalTime) {
                            // bump read size
                            newPageSize = Math.round(this.currentPageSize * (optimalTime / this.loadTime));
                            if (newPageSize > this.initialCacheCapacity) {
                                newPageSize = this.initialCacheCapacity;
                            }
                        } /*else if (this.loadTime > 1.1 * optimalTime) {
                                    // reduce read size
                                    newPageSize = Math.round(this._currentPageSize * (optimalTime / this.loadTime));
                                    if (newPageSize < MIN_PAGE_SIZE) {
                                        newPageSize = MIN_PAGE_SIZE;
                                    }
                                }*/
                        if ($dyn.log.reactList) {
                            $dyn.log.reactList("RequestedPageSize: " + this.currentPageSize + " loadTime: " + this.loadTime + " optimalTime: " + optimalTime + " NewPageSize: " + newPageSize);
                        }
                        this.currentPageSize = newPageSize;
                    }
                    if (this.fastFetch) {
                        var isFormActive = this.context && this.context.Root && this.context.Root.isNavigationActiveForm && this.context.Root.isNavigationActiveForm();
                        if ($dyn.length(this.dataSource) >= this.initialCacheCapacity || !isFormActive) {
                            // filled initial cache or form is no longer active so stop fetching more data
                            this.fastFetch = false;
                        }
                        else {
                            var moreData = this.context.MayHaveMoreData(this.LoadDirection);
                            if (!moreData) {
                                // If no more data in current direction, switch directions
                                var otherDirection = DataCache.flipDirection(this.LoadDirection);
                                moreData = this.context.MayHaveMoreData(otherDirection);
                                if (moreData) {
                                    this.LoadDirection = otherDirection;
                                }
                            }
                            if (moreData) {
                                resetDirection = false;
                                // Need to be in a timeout so that an outgoing request isn't created while processing incoming requests
                                window.setTimeout(function () {
                                    _this.dataLoadNew(function (retVal) {
                                        _this.defaultCallBack(retVal);
                                    }, _this.LoadDirection);
                                });
                            }
                            else {
                                this.fastFetch = false;
                            }
                        }
                    }
                    if (resetDirection) {
                        this.resetLoadDirection();
                    }
                }
            };
            DataCache.prototype.dataLoadNew = function (callBack, direction) {
                var _this = this;
                if (this.isDisposed) {
                    return;
                }
                if (!this.isLoading) {
                    this.isLoading = true;
                    this.prevItemsLength = $dyn.length(this.dataSource);
                    this.lastRequestedPageSize = this.currentPageSize;
                    this.startTime = Date.now();
                    if (this.maxCacheCapacity && this.prevItemsLength >= this.maxCacheCapacity) {
                        $dyn.log.reactList && $dyn.log.reactList("CurrentSize: " + this.prevItemsLength + " size limited");
                        this.isLoading = false;
                        callBack(-1);
                        return;
                    }
                    // Uncomment when the server can reduce the page size (TFS:263308)
                    /*
                    // If the amount of data requested would exceed the cache size, then only request enough records to fill the cache
                    let pageSizeToRequest = this.maxCacheCapacity && (this.prevItemsLength + this.currentPageSize > this.maxCacheCapacity) ?
                        this.maxCacheCapacity - this.prevItemsLength
                        : this.currentPageSize;
                    */
                    var pageSizeToRequest = this.currentPageSize;
                    if (pageSizeToRequest > this.currentPageSize) {
                        pageSizeToRequest = this.currentPageSize;
                    }
                    this.LoadDirection = direction;
                    var referenceIndex = 0;
                    if (direction === $dyn.ui.ScrollDirection.down) {
                        referenceIndex = $dyn.length(this.dataSource) - 1;
                    }
                    var positionalParams = [];
                    if ($dyn.value(this.dataSource)[referenceIndex]) {
                        positionalParams.push($dyn.value(this.dataSource)[referenceIndex].masterTrackingId);
                    }
                    else {
                        positionalParams.push(0);
                    }
                    positionalParams.push(pageSizeToRequest);
                    positionalParams.push(direction);
                    $dyn.callFunction(this.loadFunction, this.context, positionalParams, callBack, undefined, // complete
                    undefined, // beforeExecute
                    undefined, // throttle
                    function () {
                        _this.isLoading = false;
                        _this.fastFetch = false;
                        callBack(-1);
                        _this.resetLoadDirection();
                    });
                }
                else {
                    callBack(-1);
                }
            };
            DataCache.prototype.resetLoadDirection = function () {
                var _this = this;
                // This needs to happen after the render since LoadDirection is passed in as a prop
                if (this.hasRenderCallPending()) {
                    this.resetObserver = $dyn.observe(this.context.HasRenderCallPending, function (value) {
                        if (!value) {
                            _this.LoadDirection = $dyn.ui.ScrollDirection.none;
                            _this.resetObserver = null;
                            return false;
                        }
                    }, this, undefined, true);
                }
                else {
                    this.LoadDirection = $dyn.ui.ScrollDirection.none;
                }
            };
            DataCache.prototype.hasRenderCallPending = function () {
                if (this.context && this.context.HasRenderCallPending) {
                    return this.context.HasRenderCallPending();
                }
                return false;
            };
            DataCache.prototype.turnOffFastFetch = function () {
                this.fastFetch = false;
            };
            DataCache.prototype.dispose = function () {
                if (this.modelCollection) {
                    if (this.modelCollection.onClear && this.clearSubscription) {
                        this.modelCollection.onClear.unsubscribe(this.clearSubscription);
                    }
                    var dsName = this.modelCollection.name;
                    if (this.context) {
                        var rootId = this.context.Root && this.context.Root.Id;
                        if ($dyn.DataCacheManager[rootId] && $dyn.DataCacheManager[rootId][dsName]) {
                            delete $dyn.DataCacheManager[rootId][dsName][this.context.Name];
                            var remainingDataCaches = Object.keys($dyn.DataCacheManager[rootId][dsName]);
                            if (remainingDataCaches.length > 0) {
                                $dyn.DataCacheManager[rootId][dsName][remainingDataCaches[0]].isPrimary = true;
                            }
                        }
                    }
                }
                this.context = null;
                this.loadFunction = null;
                this.modelCollection = null;
                this.dataSource = null;
                this.isDisposed = true;
            };
            return DataCache;
        }());
        reactGrid.DataCache = DataCache;
    })(reactGrid = $dyn.reactGrid || ($dyn.reactGrid = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=DataCache.js.map
